import { render, staticRenderFns } from "./MinimizedItemsWindow.vue?vue&type=template&id=1d5749d5&scoped=true&"
import script from "./MinimizedItemsWindow.vue?vue&type=script&lang=js&"
export * from "./MinimizedItemsWindow.vue?vue&type=script&lang=js&"
import style0 from "./MinimizedItemsWindow.vue?vue&type=style&index=0&id=1d5749d5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5749d5",
  null
  
)

export default component.exports